import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { StoreDetailSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/work-schedule/_layout/shifts/$storeId/')({
  validateSearch: zodValidator(StoreDetailSearchSchema)
});